import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { BackButton } from 'legacyComponents/buttons/backButton';
import {
  MainWrapper,
  HeaderMarginTop as Main,
  BlueTopBar,
  BlueTopBarTitle,
} from 'legacyComponents/styled/lib';
import { media } from 'legacyComponents/styled/styleUtils';
import PropTypes from 'prop-types';

import { goBack } from 'core/routing';

@observer
export class SubPage extends React.Component {
  // TODO:
  // - media query widths
  render() {
    const { title, backButton, children } = this.props;
    return (
      <Main>
        <BlueTopBar>
          <TitleWrapper>
            {backButton ? <BackButton onclick={goBack} /> : ''}
            <BlueTopBarTitle>{title}</BlueTopBarTitle>
          </TitleWrapper>
        </BlueTopBar>
        <MainWrapper subPage>
          <ContentWrapper>{children}</ContentWrapper>
        </MainWrapper>
      </Main>
    );
  }
}

const TitleWrapper = styled.div`
  position: relative;
  display: block;
  width: 1135px;
  margin: 0 auto;
  ${media.l`
    width: 1030px;
  `};
  ${media.m`
    width: calc(100% - 40px);
  `};
  ${media.m`
    width: 100%;
  `};
`;

const ContentWrapper = styled.div`
  margin: -45px auto 120px auto;
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.color.wfWhite};
  display: block;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0 1px;
  padding: 40px 30px 0;
  z-index: 2;
  ${media.l`
    width: 1000px;
  `};
  ${media.m`
    width: 100%;
  `};
  ${media.s`
    padding: 25px 15px 0px;
  `};
`;

SubPage.propTypes = {
  title: PropTypes.string,
  backButton: PropTypes.bool,
  children: PropTypes.node,
};
